import React, { useState } from "react";
import SubHeaderBanner from "../../components/SubHeaderBanner";
import macauSponsor from "../../assets/images/shakehand4.jpg";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import "./style.scss";

const sponsorPackages = [
  {
    title: "Platinum Sponsor",
    description: "",
    price: "7,500",
    details: [
      <>
        <strong>Premium booth </strong>
      </>,
      <>
        <strong>Logo on all materials </strong>
      </>,
      <>
        <strong>Speaking slot</strong>
      </>,
      <>
        <strong>Social features</strong>
      </>,
    ],
  },
  {
    title: "Gold Sponsor",
    description: "",
    price: "5,800",
    details: [
      <>
        <strong>Booth presence</strong>
      </>,
      <>
        <strong>Logo inclusion</strong>
      </>,
      <>
        <strong>Social highlights</strong>
      </>,
    ],
  },
  {
    title: "Silver Sponsor",
    description: "",
    price: "4,900",
    details: [
      <>
        <strong>Booth presence</strong>
      </>,
      <>
        <strong>Logo on select event items</strong>
      </>,
    ],
  },
  {
    title: "Lanyard Sponsor",
    description: "Branding on all delegate lanyards",
    price: "1,500",
    sponsors: [
      {
        name: "IFS Group",
        logo: "IFS.png",
        url: "https://www.ifssac.com/",
      },
    ],
    details: [],
  },
  {
    title: "Cocktail Sponsor",
    description: "Host our evening cocktail session",
    price: "2,800",
    details: [],
  },
  {
    title: "Lunch Sponsor",
    description: "Sponsor a lunch networking session",
    price: "2,800",
    slot: "",
    details: [],
    sponsors: [],
  },
  {
    title: "Dinner Sponsor",
    description: "Sponsor our headline dinner",
    price: "3,100",
    slot: "",
    details: [],
  },
  {
    title: "“House of Dancing Water”",
    description: "Brand visibility at the headline show",
    price: "2,800",
    slot: "",
    sponsors: [
      {
        name: "IFS Group",
        logo: "IFS.png",
        url: "https://www.ifssac.com/",
      },
    ],
    details: [],
  },
  {
    title: "Tour Sponsor",
    description: "Logo on transport/tour kits",
    price: "1,800",
    slot: "",
    details: [],
  },
  {
    title: "Golf Sponsor",
    description: "Support and brand our golf outing",
    price: "1,100",
    slot: "",
    details: [],
  },
  {
    title: "Bag Sponsor",
    description: "Co-brand the official event bag",
    price: "1,100",
    slot: "",
    details: [],
  },
  {
    title: "Shirt Sponsor",
    description: "Company logo on event shirts",
    price: "650",
    slot: "",
    details: [],
  },
  {
    title: "Pen  Sponsor",
    description: "Your pens in every welcome kit",
    price: "650",
    slot: "",
    details: [],
  },
  {
    title: "Fixed Table Sponsor",
    description: "Guaranteed table with signage for 1-on-1s",
    price: "500",
    slot: "",
    details: [],
  },
];

function Sponsor() {
  React.useEffect(() => {
    document.body.classList.add("index-page");
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    return function cleanup() {
      document.body.classList.remove("index-page");
      document.body.classList.remove("sidebar-collapse");
    };
  });

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    event.preventDefault();
  };

  return (
    <>
      <SubHeaderBanner title="Be A Sponsor" image={macauSponsor} />
      <div className="wrapper position-relative">
        <div className="container main my-lg-5 px-lg-5">
          <section className="section gb nopadtop">
            <div className="container">
              <div className="boxed boxedp4">
                <div className="row">
                  <div className="col-md-12 section-title">
                    <h2 className="text-center text-uppercase my-5">
                      Affordable Sponsorship Pricing Packages
                    </h2>
                  </div>
                </div>

                <div className="text-justify">
                  <h4>
                    <strong>Become a Sponsor</strong>
                  </h4>

                  <p className="py-5">
                    Align your brand with a global movement of action, trust,
                    and transformation. ACTnet’s Inaugural Global Kick-Off
                    Conference 2026 in Macau offers premium visibility and
                    exclusive engagement with forwarders shaping the future of
                    logistics.
                  </p>
                </div>
              </div>
            </div>
          </section>
          <section className="pb-5">
            <Box sx={{ flexGrow: 1 }}>
              <Grid container spacing={2}>
                {sponsorPackages.map((pkg, index) => (
                  <Grid item xs={12} sm={6} md={4} key={index}>
                    <Card
                      className="bg-white shadow "
                      variant="outlined"
                      sx={{
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                      }}
                    >
                      <div className="sponsor-box">
                        <div className="text-center ">
                          <>
                            {index === 20 ? (
                              <h1
                                className="mb-0 pt-4 text-white"
                                style={{
                                  display: pkg.price === "" ? "none" : "block",
                                  userSelect: "none",
                                }}
                              >
                                {pkg.price}
                              </h1>
                            ) : (
                              <h1
                                className="mb-0 pt-4"
                                style={{
                                  display: pkg.price === "" ? "none" : "block",
                                }}
                              >
                                <small
                                  className="align-top text-muted font-weight-medium"
                                  style={{
                                    fontSize: "22px",
                                    lineHeight: "45px",
                                  }}
                                >
                                  USD $
                                </small>
                                {pkg.price}
                              </h1>
                            )}

                            <p
                              className="mb-3 text-white"
                              style={{ userSelect: "none" }}
                            >
                              Available Slot
                            </p>
                          </>
                        </div>
                        <div className="bg-primary text-white text-center p-4">
                          <h3
                            className={`m-0 ${
                              pkg.sponsors?.length > 0
                                ? "text-decoration-line-through"
                                : ""
                            }`}
                          >
                            {pkg.title}
                          </h3>
                        </div>
                        <div className="p-3">
                          <span>{pkg.description}</span>
                        </div>
                        <div className="text-justify px-4">
                          <List dense>
                            {pkg.details.map((item, idx) => (
                              <ListItem key={idx} sx={{ pl: 0 }}>
                                <ListItemText primary={<span>• {item}</span>} />
                              </ListItem>
                            ))}
                          </List>
                          {pkg.sponsors && pkg.sponsors.length > 0 ? (
                            <div className="mb-4">
                              <p className="sponsoredBy my-2">Sponsored by</p>
                              <div className="flex justify-center items-center gap-4 flex-wrap h-16">
                                {pkg.sponsors.map((sponsor, sponsorIdx) => (
                                  <a href={sponsor.url} target="_blank">
                                    <img
                                      key={sponsorIdx}
                                      src={require(`assets/images/Macau-2026/sponsors/${sponsor.logo}`)}
                                      alt={`${sponsor.name} Logo`}
                                      className="max-h-12 w-50 object-contain"
                                      onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = "";
                                      }}
                                    />
                                  </a>
                                ))}
                              </div>
                            </div>
                          ) : (
                            <div className="h-24 mb-4" />
                          )}
                        </div>

                        {/* </CardContent> */}
                      </div>
                      <div className="row justify-content-center pb-4 mx-5">
                        <a
                          href="mailto:customerservice@actnet.co"
                          className="btn btn-outline-danger py-2 px-4 my-2"
                        >
                          Email Us Now
                        </a>
                      </div>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </Box>
          </section>
        </div>

        <div className="about-us section mt-5 py-5">
          <div className="container">
            <div className="row">
              <div className="align-self-center">
                <div className="services">
                  <div className="row">
                    <div className="col-lg-12">
                      <div
                        className="item wow fadeIn"
                        data-wow-duration="1s"
                        data-wow-delay="0.9s"
                      >
                        {/* <div className="icon">
                          <img src="assets/images/check.png" alt="" />
                        </div> */}
                        <div
                          className="left-image wow fadeIn text-white"
                          data-wow-duration="1s"
                          data-wow-delay="0.2s"
                        >
                          <h2 className="">Ready to Sponsor?</h2>
                        </div>
                        <div className="right-text">
                          <h4>Let’s build something legendary together.</h4>
                          <p>
                            Contact us at customerservice@actnet.co or indicate
                            your interest when registering.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Sponsor;
